import { render, staticRenderFns } from "./AddPaymentMandate.vue?vue&type=template&id=241ef516"
import script from "./AddPaymentMandate.vue?vue&type=script&lang=js"
export * from "./AddPaymentMandate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports